import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Amparos } from './amparos.model';


@Injectable({
  providedIn: 'root'
})
export class AmparosService {
  listAmparos:Amparos[];
  amparo:Amparos;
  private routeApi = "AdmAmparoes"
  constructor(private generalHttp:GeneralHttpService) { }

  getAmparos(){
    return new Promise((resolve, reject) => {
      this.generalHttp.getHttp(this.routeApi).then(r => { 
        this.listAmparos = r as Amparos[];
        resolve(true);
      })
      error => reject(error);
    });

  }

  getAmparosByRamo(idRamo:number){
    return this.generalHttp.getHttpById(idRamo,this.routeApi + "/ByRamo").then(r => this.listAmparos = r as Amparos []);
  }

  getAmparosByRamoSini(idRamo:any){
    return new Promise((resolve, reject) => {
      this.generalHttp.getHttpById(idRamo,`${this.routeApi}/ByRamoSini`).then(r => { 
        this.listAmparos = r as Amparos[];
        resolve(true);
      })
      error => reject(error);
    });    
  }
  // getAmparosByRamoSini(idRamo:number){
  //   this.generalHttp.getHttpById(idRamo,this.routeApi + "/ByRamoSini").then(r => this.listAmparos = r as Amparos []);
  // }
  
  updateAmparo(form:Amparos,id:number){
    return this.generalHttp.putHttp<Amparos>(form,id,this.routeApi);
  }

  postAmparo(form:Amparos){
    return this.generalHttp.postHttp(form,this.routeApi);
  }

  getAmparoById(id:number){
    this.generalHttp.getHttpById(id,this.routeApi).then(r => this.amparo = r as Amparos);
  }

  deleteAmparo(id:number){
    return this.generalHttp.deleteHttp(id,this.routeApi);
  }

  getAmparosByRamoPromise(id: number) {
    return this.generalHttp.getHttpById(id, `${this.routeApi}/ByRamo`);
  }

  getAllAmparosPacs() {
    return this.generalHttp.getHttp(`${this.routeApi}/getAllAmparosPacs`);
  }

  getAmparosPolizaGlobal(id:number){
    return this.generalHttp.getHttpById(id, `${this.routeApi}/ByRamoPolizaGlobal`);
  }

}
